import React, { useEffect, useState } from "react";
import styles from "./createAccount.module.scss";
import Input from "../manageOrders/input";
import Button from "../manageOrders/button";
import { useHistory } from "react-router-dom";
var CryptoJS = require("crypto-js");
// import { CustomerContext } from "src/context/CustomerContext";

const Index = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [isValidPhone, setIsValidPhone] = useState(false);
  const [disableButton, setDisableButton] = useState(true);
  const history = useHistory();

  const handleChange = (e, type, changeState) => {
    if (type === "phoneNumber") {
      const val = phoneNumberChange(e);
      changeState(val);
    } else if (type === "otp") {
      const val = otpChange(e);
      changeState(val);
    } else {
      changeState(e.target.value);
    }
  };

  const otpChange = (e) => {
    if (e.target.value && /^[0-9]/gi.test(e.target.value)) {
      let val = e.target.value.replace(/[^\d]/g, "");
      if (val.length > 4) {
        return otp;
      } else {
        return val;
      }
    }
  };

  const phoneNumberChange = (e) => {
    if (e.target.value && /^[0-9]/gi.test(e.target.value)) {
      let val = e.target.value.replace(/[^\d]/g, "");
      if (val.length === 1 && val < 6) {
        return;
      }
      if (val.length > 10) {
        return;
      } else {
        return val;
      }
    }
  };

  const validateEmail = () => {
    const emailFilter =
      /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (emailFilter.test(String(email)?.trim())) {
      setIsValidEmail(true);
    } else {
      setIsValidEmail(false);
    }
  };

  const validatePhone = () => {
    if (phone?.length === 10) {
      setIsValidPhone(true);
    } else {
      setIsValidPhone(false);
    }
  };

  const handleSubmit = () => {
    // create account,
    // redirect to create new order page
    console.log("clicked");
    loginForNewUser();
  };

  const loginForNewUser = () => {
    let data = {
      otp: CryptoJS.AES.encrypt(otp, "123456789").toString(),
      newUser: true,
      name: name,
      email: email,
      mobileNumber: phone,
      // dialingCode: loginContext.state.selectedCountry.dialingCode,
      // countryCode: loginContext.state.selectedCountry.countryCode,
      // verificationId: loginContext.state.accountDetails.verificationId,
      captchaInfo: {
        gcaptcha: localStorage.getItem("tokenC"),
        fingerPrint: "",
        storageId: localStorage.getItem("storageId"),
      },
    };

    console.log("data", data);
  };

  useEffect(() => {
    validateEmail();
    validatePhone();
    if (name && isValidEmail && isValidPhone && otp) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  }, [name, email, phone, otp]);

  useEffect(() => {
    if (name && isValidEmail && isValidPhone && otp) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  }, [isValidEmail, isValidPhone]);

  return (
    <div className={styles["wrapper"]}>
      <div className={styles["one"]}>
        <img
          src="https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/extendedWarranty/BackArrowWithWhiteBackground.svg"
          alt="back"
          onClick={() => {
            history.goBack();
          }}
        />
        <div>
          <h2>Setup new Ola account</h2>
          <p>Some description</p>
        </div>
      </div>
      <div className={styles["two"]}>
        <Input
          placeholder="Name"
          value={name}
          onChange={(e) => {
            handleChange(e, "text", setName);
          }}
        />
        <Input
          placeholder="Phone number"
          type="phoneNumber"
          value={phone}
          maxlength="10"
          onChange={(e) => {
            handleChange(e, "phoneNumber", setPhone);
          }}
          hasError={!isValidPhone && phone?.length > 0}
        />
        <Input
          placeholder="Email"
          value={email}
          type="text"
          onChange={(e) => {
            handleChange(e, "text", setEmail);
          }}
          hasError={!isValidEmail && email?.length > 0}
        />
        <Input
          placeholder="OTP"
          value={otp}
          type="otp"
          onChange={(e) => {
            handleChange(e, "otp", setOtp);
          }}
        />

        <div className={styles.resendOtp}>
          Didn’t get the OTP? <span> Resend </span>
        </div>
        <Button label="Next" onClick={handleSubmit} disabled={disableButton} />
      </div>
      <div className={styles["three"]}>
        <p>
          By continuing, you agree to <span>T&C</span> &{" "}
          <span>Privacy Policy</span>
        </p>
      </div>
    </div>
  );
};

export default Index;
